import { GameListConfig } from '../shares/model/swipe';
import { GameLaunchConfig } from '../shares/types/SwipeSDKConfigType';

interface RouteParams {
  [key: string]: string;
}

interface QueryString {
  [key: string]: string;
}

export const generateQueryParams = (
  {
    routeParams,
    queryString,
  }: { routeParams: RouteParams; queryString: QueryString },
  gameId: string | null = '',
  token = '',
): string => {
  const routeParamsModify: RouteParams = {
    ...routeParams,
    ...(gameId && { gameId }),
  };

  const routeParamData = Object.keys(routeParamsModify).reduce(
    (acc, routeParam) => {
      return acc + '/' + routeParamsModify[routeParam];
    },
    '',
  );

  const queryStringModify: QueryString = {
    ...queryString,
    ...(token && { token }),
  };

  const queryStringData =
    Object.keys(queryStringModify).length > 0
      ? '?' + new URLSearchParams(queryStringModify).toString()
      : '';

  return routeParamData.replace(/\/$/, '') + queryStringData;
};

export const getGameLaunchUrl = (
  swipeSDKConfig: GameLaunchConfig | GameListConfig,
  gameId: string | null = '',
  token = '',
): string => {
  const configWithStringTypes = {
    routeParams: swipeSDKConfig.routeParams as Record<string, string>,
    queryString: swipeSDKConfig.queryString as Record<string, string>,
  };

  const gameLaunchUrl = `${swipeSDKConfig?.remoteApiEndPoint}${generateQueryParams(
    configWithStringTypes,
    gameId,
    token,
  )}`;

  return gameLaunchUrl;
};

export const getGameListUrl = (
  swipeSDKConfig: GameListConfig,
  tenantToken: string | null = '',
  locale = 'en-GB',
  type: 'SWIPE' | 'MINIGAME' = 'SWIPE',
): string => {
  const base = String(swipeSDKConfig?.remoteApiEndPoint || '').replace(
    /\/$/,
    '',
  );

  const token =
    tenantToken ||
    swipeSDKConfig.routeParams?.tenant ||
    swipeSDKConfig.queryString?.tenant ||
    '';

  const envParam =
    (process.env.NX_GAME_LIST_ENV as string) || process.env.NODE_ENV || '';

  const finalLocale = String(swipeSDKConfig.queryString?.locale || locale);

  const path = token
    ? `/${token}/ordered-games/${type}`
    : `/ordered-games/${type}`;

  const query = {
    locale: finalLocale,
    env: envParam,
  };

  const queryString = Object.keys(query).length
    ? '?' + new URLSearchParams(query).toString()
    : '';

  return `${base}${path}${queryString}`;
};
